const debug = false

const datos = {
    urlapi: debug === true ? 'http://localhost:4000' : 'https://tremus-cafeteria.delpasystem.com',
    async_storage_key: "tr_grz"
}

module.exports = datos